<template>

   <Dialog   
      position="top"
      v-model:visible="showThisModel"
      style="width: 80%;"
      :modal="true"      
      :maximizable="true"
      :focusTrap="false"
    >
      <div class="container">
        <div class="row mt-3 mb-3">
          <button type="button" 
           @click="showCheckInModalNew()"
           class="btn btn-outline-info col-12">
            This is a New Patient
          </button>
        </div>
      </div>

      <!-- === Merge Patient Panel ALL ==== -->
      <hr class="solid text-black-50" />
      <!-- <div class="row">
        <div class="col-12">
          <form class="floating-labels">
            <div class="row">
              <div class="form-group m-b-40" style="margin-left: 10px">
                <input
                  type="text"
                  class="form-control"
                  id=""
                  placeholder=""
                /><span class="bar"></span>
                <label for="">Search By First Name</label>
              </div>
              <div class="form-group m-b-40" style="margin-left: 10px">
                <input
                  type="text"
                  class="form-control"
                  id=""
                  placeholder=""
                /><span class="bar"></span>
                <label for="">Search By Last Name</label>
              </div>
              <div class="form-group m-b-40" style="margin-left: 10px">
                <input
                  v-mask="'###-###-####'"
                  type="tel"
                  class="form-control"
                  id=""
                  placeholder=""
                /><span class="bar"></span>
                <label for="">Search By Phone</label>
              </div>
              <div class="form-group m-b-40" style="margin-left: 10px">
                <input type="date" class="form-control" id="" /><span
                  class="bar"
                ></span>
              </div>
            </div>
          </form>
        </div>
      </div> -->

       <PatientsSearchComponent
          @apply-search-click="applySearchClick()"
          :called_by="'VeinCheckInModal'"
        ></PatientsSearchComponent>

      <!-- === Merge Patient Panel ==== -->

      <template #header>
        <h3 style="font-weight:900;">
          Search in your Practice Patient Profile Database
        </h3>
      </template>
      <!-- === Veins Patient - Suggested === -->
      <div class="tab-pane fade in active show" id="veinsPanel" role="tabpanel">
        <!-- Body -->
          <div>
         <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
            <div class="dataTables_length">
                  <span style="margin-right: 10px"
                    ><label for="">Show </label>
                  </span>
                  <select
                    v-model="pageSize"
                    class="form-control form-control-sm"
                    aria-label="Default select example"
                    @change="pageChange(1)"
                  >
                    <option selected>50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                  </select>

                  <span style="margin-left: 10px">
                    <label for=""> Entries </label></span
                  >
                </div>
                </div>
            <table
              class="
                          table
                          display
                          table-bordered table-striped
                          no-wrap
                        "
            >
              <thead class="thead-dark">
                <tr>
                <th style="text-align:start;">
                      PT ID
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(0)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                     <th style="text-align:start;">
                      External Id
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(1)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                      <th style="text-align:start;">
                      First Name
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(2)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                  <th style="text-align:start;">
                      Last Name
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(3)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                      <th style="text-align:start;">
                      DOB
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(4)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                        <th style="text-align:start;">
                      Email
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(5)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                         <th style="text-align:start;">
                      Phone
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(6)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pat, ndx04) in suggestedPatients" :key="ndx04">
                  <td>
                    <button
                      class="
                                  btn btn-facebook btn-sm
                                  waves-effect waves-light
                                "
                      @click="showCheckInModal(pat)"
                      type="button"
                    >
                      {{ pat.ptid }}
                    </button>
                  </td>
                  <td>{{ pat.externalId }}</td>
                  <td>{{ pat.firstName }}</td>
                  <td>{{ pat.lastName }}</td>
                  <td>{{ pat.dob }}</td>
                  <td>
                    {{ pat.email }}
                  </td>
                  <td>{{ pat.phone }}</td>
                </tr>
              </tbody>
            </table>
          </div>
              <!--show pagination--> 
          <nav aria-label="Page navigation">
            <span
              style="padding-left: 40px"
              v-if="totalRows < pageSize * pageNumber"
              >showing {{ totalRows }} of {{ totalRows }} records</span
            >
            <span style="padding-left: 40px" v-else
              >showing {{ pageSize * pageNumber }} of
              {{ totalRows }} records</span
            >
            <ul class="pagination" style="float: right">
              <li class="page-item colorActive">
                <span v-if="pageNumber == 1">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Previous')"
                  >
                    Previous
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Previous')">
                    Previous
                  </button>
                </span>
              </li>
                  <!--show pagination--> 
              <li v-if="showPagesMin > 1">
                 <button class="page-link" @click="pageChange(1)">
                    1
                  </button>
             </li>
              <li v-if=" showPagesMin>1 ">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                  </button>
              </li>
                 <!--show pagination--> 
              <li
                v-for="pageNum in totalPages"
                :key="pageNum"
                class="page-item colorActive"
              >
                <span v-if="pageNum >= showPagesMin && pageNum <= showPagesMax"> 
                <span v-if="pageNumber == pageNum"
                  ><button
                    class="page-link activeColor"
                    disabled
                    @click="pageChange(pageNum)"
                  >
                    {{ pageNum }}
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange(pageNum)">
                    {{ pageNum }}
                  </button></span
                >
                </span>
              </li>

              <!--show pagination-->          
              <li v-if="totalPages > 10 && (totalPages-4) >= pageNumber">
                 <button
                    disabled
                    class="page-link disabledColor"
                  >
                    ...
                  </button>
              </li>
             <li v-if="totalPages > 10 &&  (totalPages-4) >= pageNumber">
                 <button class="page-link" @click="pageChange(totalPages)">
                    {{ totalPages }}
                  </button>
             </li>
               <!--show pagination-->   
              <li class="page-item colorActive"> 
                <span v-if="pageNumber == totalPages">
                  <button
                    disabled
                    class="page-link disabledColor"
                    @click="pageChange('Next')"
                  >
                    Next
                  </button>
                </span>
                <span v-else>
                  <button class="page-link" @click="pageChange('Next')">
                    Next
                  </button>
            
                </span>
              </li>
            </ul>
          </nav>
      </div>
      <!-- === Veins Patient === -->
    </Dialog>
</template>

<script src="./mixins/VeinCheckInModal.js"></script>

<style scoped>
.activeColor{
  background-color:#fb9678;
  color: white;
}
.colorActive{
  color:#f95c2e
}
.disabledColor{
  color:gray;
  background: lightgrey;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
#td1{
  text-align: left;
  width: 320px
}
#td2{
  text-align: center;
}
</style>

